import { Card, CardHeader, Stack, Heading, CardBody, useToast, Container, Button } from "@chakra-ui/react";
import MyBreadcrumb from "components/breadcrumb/Breadcrumb";
import { FaFileExcel, FaFileCsv } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { getDocumentFile } from "service/api/document.api";
import { saveAs } from "file-saver";
import { Breadcrumb } from "types/Breadcrumb";

type ExportPageProps = {

};

/**
 * ExportPage component displays the export page for a document.
 * 
 * @component
 * 
 * @example
 * return (
 *   <ExportPage />
 * )
 */

export default function ExportPage({ }: ExportPageProps) {

  const toast = useToast();
  const selectedDocumentId = useSelector((state: any) => state.documents.selectedDocumentId);
  const selectedDocument = useSelector((state: any) => state.documents.documents.find((doc: any) => doc._id === selectedDocumentId));

  const onClickDownloadFile = (id: string, format: string) => {

    getDocumentFile(id, format).then((res: any) => {
      const blob = new Blob([res.data], { type: res.type });
      const name = res.headers["content-disposition"].split("filename=")[1];
      saveAs(blob, name);
    }).catch((err) => {

      toast({
        title: "Errore",
        description: "Errore durante il download del file",
        status: "error",
        duration: 6000,
        isClosable: true,
      });

    });

  }

  const breadcrumb: Breadcrumb = new Breadcrumb(
    [
      { label: "Esportazione documento", link: "/export", value: "", isActive: false },
    ]
  );

  return (
    <section className="dashboard-first-section">
      <Container maxW="container.lg" maxH={"container.xl"} textAlign={"left"}>
        <MyBreadcrumb breadcrumb={breadcrumb} />


        <Card minH={"60vh"}>
          <CardHeader>
            <Heading as="h1" size="xl">
              Esportazione documento {document?.title} ({selectedDocument?.code})
            </Heading>
          </CardHeader>
          <CardBody>

            <Stack direction="column" spacing={5} mt={5}>
              <Button leftIcon={<FaFileExcel />} colorScheme="green" onClick={() => onClickDownloadFile(selectedDocument._id, "xlsx")}>
                Esporta in XLSX (Excel)
              </Button>
              <Button leftIcon={<FaFileCsv />} colorScheme="teal" onClick={() => onClickDownloadFile(selectedDocument._id, "csv")}>
                Esporta in CSV
              </Button>
            </Stack>

          </CardBody>
        </Card>
      </Container>
    </section>
  );
}